// extracted by mini-css-extract-plugin
export default {"content":"style_content__duiXF"};